module.exports = __webpack_public_path__ + "img/icon-financial.58e12982.svg";